import { render } from "./AddNewNid.vue?vue&type=template&id=7b9e9c2c&ts=true"
import script from "./AddNewNid.vue?vue&type=script&lang=ts"
export * from "./AddNewNid.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__